import { Component, ViewChild, ViewContainerRef } from '@angular/core';
import { FieldWrapper } from '@ngx-formly/core';
import { LuTooltipModalComponent } from 'lu-tooltip-modal';
import { BsModalService } from 'ngx-bootstrap/modal';
import { ErrorPosition, FieldType } from '../../builders/formly-builder.models';

@Component({
	templateUrl: './default-field.component.html',
	styleUrls: ['./default-field.component.scss']
})
export class DefaultFieldWrapperComponent extends FieldWrapper {
	ErrorPosition = ErrorPosition;
	FieldType = FieldType;
	@ViewChild('fieldComponent', { read: ViewContainerRef, static: true }) declare fieldComponent: ViewContainerRef;

	constructor(private readonly bsModalService: BsModalService) {
		super();
	}

	openTooltip(): void {
		this.bsModalService.show(LuTooltipModalComponent, {
			initialState: {
				options: {
					message: this.to.tooltipMessage
				}
			}
		});
	}
}
